export default __webpack_public_path__ + "static/organizations-3-b2681a91a062b90efc323f5fd53f8fb5.jpg";